module.exports = __webpack_public_path__ + "static/media/accessory15.89fe1fc3.webp";